import { render, staticRenderFns } from "./SidebarNavigationLink.vue?vue&type=template&id=67c2e7b2"
import script from "./SidebarNavigationLink.vue?vue&type=script&lang=js"
export * from "./SidebarNavigationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports